// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./NavbarStyles";
// @otg-one/ui_components/components
import { Button, Typography } from '../index';
// @otg-one/ui_components/icons
import { OntegoSAPLogoWhite, AvatarUser, Collection } from '../../icons';
// @otg-one/ui_components/constants
import { FONT_FAMILY, Color } from "../../constants";
import Zoom from '@mui/material/Zoom';
const CollectionCart = (props) => {
    const classes = useStyles(props);
    const { collectionSize, onShoppingCartClick, style } = props;
    return (React.createElement("div", { className: classes.navbarShoppingCartIconContainer, style: style },
        React.createElement(Collection, { onClick: onShoppingCartClick }),
        React.createElement(Zoom, { in: collectionSize > 0 },
            React.createElement("div", { className: classes.navbarCollectionSizeIndicator },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 12, color: Color.neutral[900] }, collectionSize)))));
};
const AccountBox = (props) => {
    const classes = useStyles(props);
    const { avatar, onAccountBoxClick, style } = props;
    return (React.createElement(React.Fragment, null, avatar ? (React.createElement("div", { className: classes.navbarAccountImage, onClick: onAccountBoxClick, style: style },
        React.createElement("img", { src: avatar, alt: "avatar", style: {
                width: 32,
                height: 32,
                borderRadius: "50%"
            } }))) : (React.createElement("div", { className: classes.navbarAccountIconContainer },
        React.createElement(AvatarUser, { onClick: onAccountBoxClick })))));
};
export const Navbar = (props) => {
    const classes = useStyles(props);
    const { id, avatar, collectionSize, onLogoClick, onUpAndRunningClick, onAccountBoxClick, onShoppingCartClick, onLogoutClick, onPricingAndLicenseClick, style, textHardwareFinder, textPricingModel, textUpAndRunning, textLogout, accountBoxStyle, collectionCartStyle } = props;
    return (React.createElement("div", { className: classes.navbarContainer, style: style, id: id },
        React.createElement("div", { className: classes.navbar },
            React.createElement("div", { className: classes.navbarLogoContainer },
                React.createElement(OntegoSAPLogoWhite, { className: classes.navbarLogo, onClick: onLogoClick })),
            React.createElement("div", { className: classes.navbarChildContainer },
                React.createElement("a", { target: "_blank", href: "https://www.ontego.de/sap_mobility/mobile-geraete.html", style: { textDecoration: 'none' } },
                    React.createElement(Button, { type: "secondary", color: "white", 
                        // onClick={}
                        style: { marginRight: 24 } }, textHardwareFinder)),
                React.createElement(Button, { type: "secondary", color: "white", onClick: onPricingAndLicenseClick, style: { marginRight: 24 } }, textPricingModel),
                React.createElement(Button, { type: "secondary", color: "white", onClick: onUpAndRunningClick, style: { marginRight: 60 } }, textUpAndRunning),
                React.createElement(AccountBox, { avatar: avatar, onAccountBoxClick: onAccountBoxClick, style: accountBoxStyle }),
                React.createElement(CollectionCart, { collectionSize: collectionSize, onShoppingCartClick: onShoppingCartClick, style: collectionCartStyle }),
                React.createElement(Button, { id: `${id}logoutButton`, color: "white", onClick: onLogoutClick }, textLogout)))));
};
Navbar.defaultProps = {
    avatar: null,
    cart: [],
    onLogoClick: () => { },
    onUpAndRunningClick: () => { },
    onAccountBoxClick: () => { },
    onShoppingCartClick: () => { },
    onLogoutClick: () => { },
    megaDropdownComponents: React.createElement(React.Fragment, null),
    textHardwareFinder: 'Hardware Finder',
    textPricingModel: 'Pricing Model',
    textUpAndRunning: 'Up & Running',
    textLogout: 'Logout'
};
export default React.memo(Navbar);
